__turbopack_context__.v({
  "active": "carousel-module-scss-module__3UewXG__active",
  "carousel": "carousel-module-scss-module__3UewXG__carousel",
  "controlButton": "carousel-module-scss-module__3UewXG__controlButton",
  "controlButtons": "carousel-module-scss-module__3UewXG__controlButtons",
  "controls": "carousel-module-scss-module__3UewXG__controls",
  "directionButton": "carousel-module-scss-module__3UewXG__directionButton",
  "faded": "carousel-module-scss-module__3UewXG__faded",
  "nextButton": "carousel-module-scss-module__3UewXG__nextButton",
  "prevButton": "carousel-module-scss-module__3UewXG__prevButton",
  "slide": "carousel-module-scss-module__3UewXG__slide",
  "slides": "carousel-module-scss-module__3UewXG__slides",
  "slidesContainer": "carousel-module-scss-module__3UewXG__slidesContainer",
});
